import React, { useContext, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import RouteContext from 'src/routes/context';
import { getAllFilters } from '../utils/filters-config';
import { trackPriceListFilterUpdate } from '../../../tracking';
import { useProductVariantsInHeaderExperiment } from 'src/hooks/experiments';
import { saveFiltersAsUserSettings, defaultHiddenListOptions } from '../utils';
import FilterOption from './filter-option';
import { ProductFilters } from '../../../product-filters';
import { IOfferlistFilters } from '../types';
import { FilterPanel } from '../styles';

export const AllFilters: React.FC<IOfferlistFilters> = props => {
  const { variantGroups, conditions, categoryId } = props;

  const { t, market } = useContext(AppContext);
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const { filters, reload } = useContext(PriceListFilterContext);

  const showProductVariantsInHeader = useProductVariantsInHeaderExperiment();

  const [hiddenListOptions] = useState<string[]>(
    defaultHiddenListOptions(market)
  );

  const filtersConfig = getAllFilters(t, filters, hiddenListOptions);

  const onProductTypeFilterChanged = (name: string, val: boolean) => {
    const selectedFilters = {
      ...filters,
      [name]: val,
    };
    saveFiltersAsUserSettings(selectedFilters);
    trackPriceListFilterUpdate(name, val);
    reload(selectedFilters, routeDispatch);
  };

  return (
    <>
      {!showProductVariantsInHeader && (
        <ProductFilters
          variantGroups={variantGroups}
          conditions={conditions}
          categoryId={categoryId}
        />
      )}
      <FilterPanel data-testid="FilterOptions">
        {filtersConfig.map(f => {
          return (
            !f.hide &&
            !f.quickFilter && (
              <FilterOption
                key={f.name}
                name={f.name}
                defaultValue={f.checked}
                onFilterChangedHandler={onProductTypeFilterChanged}
                label={f.label}
                caption={f.caption}
              />
            )
          );
        })}
      </FilterPanel>
    </>
  );
};
